import { isValidFederalWasteCodeForImport } from "./federalWasteCodes";
import { isRecognizedStateWasteCode } from "./stateWasteCodeNormalization";

/** Checks code recognition/format; shipment-specific classification remains a separate review. */
export function invalidManifestCorrectionWasteCodes(
  field: string,
  codes: readonly string[]
): string[] {
  return codes.filter((raw) => {
    const code = raw.trim().toUpperCase();
    if (field === "federalWasteCodes") return !isValidFederalWasteCodeForImport(code);
    if (field !== "stateWasteCodes") return false;
    return !isRecognizedStateWasteCode(code);
  });
}
